import { render, staticRenderFns } from "./DropDownIcon.vue?vue&type=template&id=e968db3e"
import script from "./DropDownIcon.vue?vue&type=script&lang=ts"
export * from "./DropDownIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports